.accessibilityHeaderContainer {
  background: var(--pgm-sys-color-surface-container);
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  color: var(--pgm-sys-color-on-surface-variant);
  padding-inline: 24px;
  vertical-align: middle;
}

.accessibilityHeaderButtonsContainer {
  display: flex;
  gap: 16px;
  align-items: center;
}

.accessibilityHeaderLinksContainer {
  display: flex;
  gap: 24px;
  align-items: center;
}

.accessibilityHeaderContainer button {
  background: transparent;
  border-radius: 100%;
  width: 32px;
  height: 32px;
  color: var(--pgm-sys-color-on-surface-variant);
  border: solid 1px var(--pgm-sys-color-outline-variant);
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.15px;
  line-height: 24px;
}

@media (max-width: 1199.98px) {
  .accessibilityHeaderContainer {
    display: none;
  }
}
